import * as b2bPermissionsTypes from '../types/b2bPermissionsTypes';

// Shape returned by AdminModuleService.getModulePermissions:
//   { success, message, scope, modules }
// where scope = { scope_type, internal: { companies }, external: { companies } }.
// `scope_type` is a CSV string that may list one or BOTH types:
// "internal", "external" or "internal, external". The active boxes are every
// scope[type] whose `type` appears in scope_type (see utils/scopeType.js).
// There is NO top-level `role_type`.
const INITIAL_STATE = {
    loading: false,
    modules: [],
    scope: null,
    error: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case b2bPermissionsTypes.LOAD_B2B_PERMISSIONS_START:
            return { ...state, loading: true, error: null };
        case b2bPermissionsTypes.LOAD_B2B_PERMISSIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                modules: action.payload.modules,
                scope: action.payload.scope,
                error: null,
            };
        case b2bPermissionsTypes.LOAD_B2B_PERMISSIONS_ERROR:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
